<template>
    <div id="whiteboard-title">{{ state.title }}</div>
</template>
<script setup>
import { defineProps, reactive } from "vue";

const props = defineProps({
    title: {
        type: String,
        default: "",
    },
});

const state = reactive({
    title: props.title || "Untitled",
});
</script>
